"use client";

import React, { useState } from "react";
import GymHero from "@/components/demos/gym/GymHero";
import MembershipTiersSection from "@/components/demos/gym/MembershipTiersSection";
import FacilityShowcaseSection from "@/components/demos/gym/FacilityShowcaseSection";
import TrialPassModal from "@/components/demos/gym/TrialPassModal";
import { DemoCommercialBanner } from "@/components/demos/DemoCommercialBanner";
import { GymTier } from "@/lib/demos/gymData";

interface GymPageProps {
  currency?: "INR" | "USD";
}

export default function GymPage({ currency = "INR" }: GymPageProps) {
  const [isTrialOpen, setIsTrialOpen] = useState(false);
  const [selectedTier, setSelectedTier] = useState<string>("Executive Performance");

  const handleOpenTrial = (tierName?: string) => {
    if (tierName) setSelectedTier(tierName);
    setIsTrialOpen(true);
  };

  const handleSelectTier = (tier: GymTier) => {
    setSelectedTier(tier.name);
    setIsTrialOpen(true);
  };

  const handleScrollToTiers = () => {
    const el = document.getElementById("membership-tiers");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <GymHero
        onOpenTrialPass={() => handleOpenTrial()}
        onExploreTiers={handleScrollToTiers}
        currency={currency}
      />

      <DemoCommercialBanner
        title="Deploy This Custom Gym Management Software for Your Fitness Center"
        description="Biometric turnstile access control, automated WhatsApp membership renewal alerts, trainer commissions, and POS billing with zero recurring monthly SaaS fees."
        targetUrl="/gym-management-software"
        targetLabel="Explore Gym Software & Pricing"
        secondaryUrl="/demos/gym/crm"
        secondaryLabel="Open Club Floor CRM"
        accent="orange"
      />

      <MembershipTiersSection
        currency={currency}
        onSelectTier={handleSelectTier}
      />

      <FacilityShowcaseSection
        onOpenTrialPass={() => handleOpenTrial()}
      />

      {/* Trial Pass Modal */}
      <TrialPassModal
        isOpen={isTrialOpen}
        onClose={() => setIsTrialOpen(false)}
        currency={currency}
        preselectedTier={selectedTier}
      />
    </div>
  );
}
